import { useAppDispatch } from 'src/store/hooks';
import { handleModal } from 'src/store/actions/modal';
import { Button } from '../reusable/Buttons';
import Image from '../reusable/Image';
import { H5, Paragraph } from '../reusable/Typography';
import * as SVG from 'src/assets/icons';

const PurchaseSuccess = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="relative h-[calc(100vh-1600px)] container mx-auto flex justify-center">
      <div className="absolute top-1/2 transform translate-y-1/2 max-w-md">
        <div className="flex justify-center mb-10">
          <Image className="w-40 h-40" src={SVG.GreenCheckGiftCard} />
        </div>
        <div className="text-center">
          <H5 className="font-medium mb-2">Successful purchase</H5>
          <Paragraph>
            You’ve successfully sent 2($80) gift cards to Solaru Olusegun
          </Paragraph>
        </div>
        <div>
          <Button
            onClick={() => dispatch(handleModal(false))}
            className="w-[450px] mt-10 text-sm"
          >
            Go back home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseSuccess;
